/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { config } from '@/lib/config';
import { formatReleaseDate, LATEST_RELEASE_DATE } from '@/features/releaseNotes/data';
import { Modal } from './Modal';

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="about-row">
      <span className="about-k">{label}</span>
      <span className="about-v">{value}</span>
    </div>
  );
}

/** About dialog: describes the eDiagnostics application and shows its build metadata. */
export function AboutModal({ onClose }: { onClose: () => void }) {
  const { t, i18n } = useTranslation();

  return (
    <Modal onClose={onClose} labelledBy="about-title">
      <div className="modal about-modal">
        <div className="modal-head">
          <Icon
            name="info"
            size={22}
            style={{ color: 'var(--color-primary-text)', flex: 'none' }}
          />
          <div className="mh-titles">
            <h2 id="about-title">{t('about.title')}</h2>
            <div className="mh-sub">{t('about.subtitle')}</div>
          </div>
          <div className="sp" style={{ flex: 1 }} />
          <button className="iclose" onClick={onClose} aria-label={t('common.close')}>
            <Icon name="close" size={18} />
          </button>
        </div>

        <div className="ov-body about-body">
          <p className="about-desc">{t('about.description')}</p>
          <Row label={t('about.labels.application')} value={config.appName} />
          <Row label={t('about.labels.version')} value={config.appVersion} />
          <Row label={t('about.labels.build')} value={config.buildNumber} />
          <Row
            label={t('about.labels.released')}
            value={formatReleaseDate(LATEST_RELEASE_DATE, i18n.language)}
          />
        </div>

        <div className="ov-foot set-foot">
          <button className="btn btn-pri" onClick={onClose}>
            {t('common.close')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
